import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@mui/material";
import ErrorModal from "../../../utils/ErrorModal";
import { useParams } from "react-router-dom";

const Department = () => {
  const [departments, setDepartments] = useState([]);
  const [deptName, setDeptName] = useState("");
  const [editingNames, setEditingNames] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { orgId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const admin = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/department?orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setDepartments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleAddDepartment = async () => {
    if (!deptName.trim()) return;

    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/department`,
        {
          username: admin,
          orgId: orgId,
          name: deptName.trim(),
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );

      setDeptName("");
      fetchDepartments();
    } catch (err) {
      setErrorMsg(
        err?.response?.data?.Exception || "Department already exists"
      );
      setErrorModal(true);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleUpdateDepartment = async (deptId) => {
    const updatedName = editingNames[deptId];
    if (!updatedName?.trim()) return;

    setBtnLoading(true);
    try {
      await axios.put(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/department?deptId=${deptId}&name=${updatedName.trim()}`,
        {},
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );

      fetchDepartments();
    } catch (err) {
      console.error(err);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}

      <div className="dashboard-container">
        <h2>Add Department</h2>

        <div style={{ display: "flex", gap: 20, maxWidth: 500 }}>
          <input
            type="text"
            placeholder="Department Name"
            value={deptName}
            onChange={(e) => setDeptName(e.target.value)}
          />
          <Button
            sx={{ margin: "5px 0 20px 0 !important", width: "50%" }}
            className="btn-contained"
            onClick={handleAddDepartment}
          >
            Add
          </Button>
        </div>

        <h2 style={{ marginTop: 30 }}>Departments</h2>

        <table
          border={1}
          style={{
            borderCollapse: "collapse",
            width: "100%",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th style={{ padding: 20, width: "60%" }}>Department Name</th>
              <th style={{ width: "30%" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {departments.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ padding: 20 }}>
                  No departments added yet.
                </td>
              </tr>
            ) : (
              departments.map((dept, i) => (
                <tr key={dept.deptId}>
                  <td>{i + 1}</td>
                  <td style={{ padding: 20 }}>
                    <input
                      className="table-input"
                      type="text"
                      value={editingNames[dept.deptId] ?? dept.name}
                      onChange={(e) =>
                        setEditingNames((prev) => ({
                          ...prev,
                          [dept.deptId]: e.target.value,
                        }))
                      }
                    />
                  </td>
                  <td>
                    <Button
                      className="btn-outlined"
                      sx={{ margin: "0 !important" }}
                      onClick={() => handleUpdateDepartment(dept.deptId)}
                    >
                      Update
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <ErrorModal
        open={errorModal}
        handleClose={() => setErrorModal(false)}
        msg={errorMsg}
      />
    </div>
  );
};

export default Department;
